import { render, staticRenderFns } from "./transport_contracts.vue?vue&type=template&id=5598c7ea&"
import script from "./transport_contracts.vue?vue&type=script&lang=js&"
export * from "./transport_contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports